const HISTORY_KEY = 'pageHistory'

const isThirdPartyOrderDetailReturn = (path = '') => {
  const [pathOnly, queryString = ''] = String(path).split('?')
  if (pathOnly !== '/order/detail' || !queryString) return false
  const params = new URLSearchParams(queryString)
  return params.get('fromThirdParty') === '1' && !params.get('orderId')
}

export default {
  methods: {
    goBack() {
      let history = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || '[]')
      history = history.filter(item => !isThirdPartyOrderDetailReturn(item))
      
      // 如果历史记录为空，回到首页
      if (history.length === 0) {
        sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history))
        this.$router.replace('/index')
        return
      }
      
      // 取最后一条记录并出栈
      const prevPage = history.pop()
      
      // 保存更新后的历史记录
      sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history))
      
      // 设置回退标志，避免死循环
      sessionStorage.setItem('isGoBack', 'true')
      
      // 跳转到这个页面
      this.$router.replace(prevPage)
    }
  }
}
